export default {
    root: ({ props }) => ({
        class: [
            {
                'flex flex-wrap items-center justify-center gap-2': props.mode === 'basic',
            },
        ],
    }),
    input: {
        class: 'hidden',
    },
    header: {
        class: [
            // Flexbox
            'hidden',
            'flex',
            'flex-wrap',

            // Colors
            'bg-neutral-high_pure',
            'text-neutral-low_dark',

            // Spacing
            'p-[1.125rem]',
            'gap-2',

            // Borders
            'border',
            'border-solid',
            'border-neutral-high_dark',
            'dark:border-neutral-low_dark',
            'border-b-0',

            // Shape
            'rounded-tr-lg',
            'rounded-tl-lg',
        ],
    },
    content: {
        class: [
            // Position
            'relative',

            // Colors
            'bg-neutral-high_pure',
            'text-neutral-low_dark',

            // Spacing
            'p-0',

            // Borders
            'border-0 border-t-0',

            // Shape
            'rounded-b-lg',

            //ProgressBar
            '[&>[data-pc-name=pcprogressbar]]:absolute',
            '[&>[data-pc-name=pcprogressbar]]:w-full',
            '[&>[data-pc-name=pcprogressbar]]:top-0',
            '[&>[data-pc-name=pcprogressbar]]:left-0',
            '[&>[data-pc-name=pcprogressbar]]:h-1',
        ],
    },
    file: {
        class: [
            // Flexbox
            'flex',
            'items-center',
            'flex-wrap',

            // Spacing
            'p-4',
            'mb-2',
            'last:mb-0',

            // Borders
            'border',
            'border-neutral-high_dark',
            'gap-4',

            // Shape
            'rounded-lg',
        ],
    },
    fileThumbnail: 'shrink-0',
    fileName: 'font-medium text-neutral-low_pure break-all',
    fileSize: 'text-sm text-neutral-low_medium',
};
